import {Column, HeaderProps} from 'react-table'
import SelectionHeader from '../../../utils/components/table-content/SelectionHeader'
import {ListViewContext} from '../../../utils/contextProvider/ListViewProvider'
import {SelectionCell} from '../../../utils/components/table-content/SelectionCell'
import {PropsWithChildren} from 'react'
import {CustomHeader} from '../../../utils/components/table-content/CustomHeader'
import ActionCell from '../../../utils/components/table-content/ActionCell'
import {IMenu} from './_modal'

const menuListColumn = (handleSelect: (id: number) => void): ReadonlyArray<Column<IMenu>> => [
  {
    Header: (props) => <SelectionHeader tableProps={props} context={ListViewContext} />,
    id: 'selection',
    Cell: ({...props}) => (
      <SelectionCell id={props.data[props.row.index].id_menu} context={ListViewContext} />
    ),
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IMenu>>) => (
      <CustomHeader tableProps={props} title='menu name' className='min-w-100px' />
    ),
    id: 'menu_name',
    accessor: 'menu_name',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IMenu>>) => (
      <CustomHeader tableProps={props} title='icon' className='min-w-100px' />
    ),
    id: 'icon',
    accessor: 'icon',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IMenu>>) => (
      <CustomHeader tableProps={props} title='Serial' className='min-w-100px' />
    ),
    id: 'sl_no',
    accessor: 'sl_no',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IMenu>>) => (
      <CustomHeader tableProps={props} title='Action' className='min-w-100px text-end' />
    ),
    id: 'action',
    Cell: ({...props}) => (
      <ActionCell id={props.data[props.row.index].id_menu} selectItem={handleSelect} />
    ),
  },
]

export default menuListColumn
